import React from 'react';

import Carousel from '../../../components/Carousel.jsx';
import ImagePlusText from '../../modules/ImagePlusText.jsx';
import ProductSlugFacade from '../../modules/products/ProductSlugFacade.jsx';
import HtmlText from '../../modules/HtmlText.jsx';
import Gallery from '../../modules/Gallery.jsx';
import PromoImages from '../../modules/promo/PromoImages.jsx';
import TopBrands from '../../modules/brands/TopBrands.jsx';
import Video from '../../modules/Video.jsx';
import VideoVimeo from '../../modules/VideoVimeo.jsx';
import VideoEmbed from '../../modules/VideoEmbed.jsx';
import TopBlogPosts from '../../modules/blogposts/TopBlogPosts.jsx';
import ButtonGroup from '../../modules/ButtonGroup.jsx';
import Share from '../../modules/Share.jsx';
import RandomButtonPicker from '../../modules/RandomButtonPicker.jsx';
import CmsModules from '../../../services/cms/CmsModules';
import { generateCmsUrl } from '../../../services/cms/cmsService';

import './BlogPageBase.scss';

const BlogPageBase = ({
    mainCreativeWork,
    headline,
    alternativeHeadline,
    datePublished,
    author,
    content,
    virtualdir,
}) => {
    const mainImageUrl = mainCreativeWork.mainImage.data.attributes.url;
    return (
        <>
            <div
                className='banner-main'
                style={{
                    backgroundImage: `url('${generateCmsUrl(mainImageUrl)}')`,
                }}></div>
            <div className='services_main'>
                <div className='container'>
                    <div className='creative_taital'>
                        <h1 className='creative_text title'>{headline}</h1>
                        <p className='creative_text subtitle'>
                            {alternativeHeadline}
                        </p>
                        <p className='creative_text author_date'>
                            {author} |{' '}
                            {new Date(datePublished).toLocaleDateString()}
                        </p>
                        <div className='blog-content'>
                            <Share virtualdir={virtualdir} />
                            {content.map((c, idx) => {
                                if (
                                    c.__typename === CmsModules.ProductGallery
                                ) {
                                    return (
                                        <ProductSlugFacade
                                            key={idx}
                                            products={c.products}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.ImagePlusText
                                ) {
                                    return (
                                        <ImagePlusText
                                            key={idx}
                                            orientation={c.orientation}
                                            url={c.image.data.attributes.url}
                                            text={c.text}
                                            imageUrl={c.imageUrl}
                                            caption={c.imageCaption}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.HtmlText
                                ) {
                                    return (
                                        <HtmlText
                                            content={c.htmlText}
                                            key={idx}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.Gallery
                                ) {
                                    return (
                                        <Gallery
                                            key={idx}
                                            imagesArray={c.images}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.TopBrands
                                ) {
                                    return (
                                        <TopBrands
                                            key={idx}
                                            brands={c.brands}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.PromoImages
                                ) {
                                    return (
                                        <PromoImages
                                            key={idx}
                                            promoImages={
                                                c.promoImages.promoImages
                                            }
                                        />
                                    );
                                } else if (c.__typename === CmsModules.Video) {
                                    return (
                                        <Video
                                            key={idx}
                                            video={c.video}
                                            isBanner={c.isBanner}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.VideoVimeo
                                ) {
                                    return (
                                        <VideoVimeo
                                            key={idx}
                                            idvideo={c.idvideo}
                                            overlayText={c.overlayText}
                                            position={c.position}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.VideoEmbed
                                ) {
                                    return (
                                        <VideoEmbed
                                            key={idx}
                                            externalVideoEmbed={
                                                c.externalVideoEmbed
                                            }
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.TopBlogPosts
                                ) {
                                    return (
                                        <TopBlogPosts
                                            key={idx}
                                            blogposts={c.items.data}
                                            showInCarousel={c.showInCarousel}
                                        />
                                    );
                                } else if (
                                    c.__typename === CmsModules.ButtonGroup
                                ) {
                                    return (
                                        <ButtonGroup
                                            key={idx}
                                            buttonsList={c.buttonsList}
                                            orientation={
                                                c.orientationComponentRepeatableComponentsButtonGroup
                                            }
                                            alignment={c.alignment}
                                        />
                                    );
                                } else if (c.__typename === CmsModules.Button) {
                                    return (
                                        <ButtonGroup
                                            key={idx}
                                            buttons={[c]}
                                            orientation='row'
                                            alignment='center'
                                        />
                                    );
                                } else if (
                                    c.__typename ===
                                    CmsModules.RandomButtonPicker
                                ) {
                                    return (
                                        <RandomButtonPicker
                                            key={idx}
                                            links={c.links}
                                            buttonText={c.buttonText}
                                        />
                                    );
                                } else {
                                    return (
                                        <p
                                            key={idx}
                                            style={{ display: 'none' }}>
                                            {console.error(
                                                `Component ${c.__typename} missing`
                                            )}
                                        </p>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogPageBase;
